import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  NgZone,
} from '@angular/core';
import {
  MatLegacySnackBar as MatSnackBar,
  MatLegacySnackBarConfig as MatSnackBarConfig,
} from '@angular/material/legacy-snack-bar';
import { GradeUnitService } from '@app/infrastructure/core/services/api/grade-unit.service';
import {
  GradeUnitRequest,
  IGradeUnitListItemDTO,
  IGradeUnitRequest,
} from '@app/infrastructure/models/grade-unit/grade-unit';
import { MessageSnackbarComponent } from '@app/infrastructure/shared/components/message-snackbar/message-snackbar.component';
import { SaveCancelService } from '@app/infrastructure/core/services/state/save-cancel.service';

export enum ColorScheme {
  PURPLE = 'PURPLE',
  BLUE = 'BLUE',
}

@Component({
  selector: 'app-grade-unit-hero',
  templateUrl: './grade-unit-hero.component.html',
  styleUrls: ['./grade-unit-hero.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GradeUnitHeroComponent implements OnInit {
  @Input() card: IGradeUnitListItemDTO;
  @Input() color: string = 'PURPLE';
  @Input() actions: boolean = false;
  @Input() showStartDate: boolean = true;
  @Input() showImageData: boolean = true;
  @Input() isGrades: boolean = false;
  colorScheme: ColorScheme = ColorScheme.PURPLE;

  startDate: string;
  articleText: string;
  changeStartDate: boolean = false;

  constructor(
    private snackBar: MatSnackBar,
    private zone: NgZone,
    private gradeUnitService: GradeUnitService,
    private saveCancelService: SaveCancelService,
  ) {}

  ngOnInit(): void {
    this.articleText = this.card?.unitDescription;
    this.startDate = this.getStartDate();
  }

  getStartDate() {
    // TODO: Implement start date when pacing guide implemented...
    return '1/1/1';
  }

  toggleEditStartDate() {
    this.changeStartDate = !this.changeStartDate;
  }

  async onAssignClick() {
    const success = false;
    let msg: string;
    // short circuit if student

    try {
      const request: IGradeUnitRequest = new GradeUnitRequest();

      await this.gradeUnitService
        .updateGradeUnit(request, this.card?.unitNumber)
        .subscribe((response) => {});
      msg = 'Start Date Successfully Assigned';
    } catch (err) {
      msg = `An error occurred attempting to assign Start Date ${err}`;
    } finally {
      this.changeStartDate = false;
      if (success) {
        this.showSuccess([msg]);
      } else {
        this.showError([msg]);
      }
    }
  }

  onChangeClick() {
    this.toggleEditStartDate();
  }

  public showSuccess(message: string[]): void {
    const configSuccess: MatSnackBarConfig<MessageSnackbarComponent> = {
      panelClass: 'success',
      verticalPosition: 'bottom',
      duration: 3000,
    };
    this.openSnackbar(message, configSuccess);
  }

  public showError(message: string[]): void {
    const configError: MatSnackBarConfig<MessageSnackbarComponent> = {
      panelClass: 'error',
      verticalPosition: 'top',
      duration: 10000,
    };
    this.openSnackbar(message, configError);
  }

  private openSnackbar(
    message: string[],
    config: MatSnackBarConfig<MessageSnackbarComponent>,
  ) {
    // Wrap snackbar call in zone invocation to fix rendering inconsistencies
    this.zone.run(() => {
      this.saveCancelService.setDisabledState(false);
      this.snackBar.openFromComponent(MessageSnackbarComponent, {
        data: message,
        ...config,
      });
    });
  }

  // Enums do not exist in JS so we can't use ColorScheme.Color in template
  // instead,  provide mechanism to set scheme
  setColorScheme(color: string) {
    return ColorScheme[color];
  }

  getSchemeColor(): string {
    const scheme = this.setColorScheme(this.color);
    switch (scheme) {
      case ColorScheme.PURPLE:
        return 'purple';
      case ColorScheme.BLUE:
        return 'blue';
    }
  }
}
